
import { Terminal } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import { motion } from 'framer-motion';
import { fadeIn, fadeInRight } from '@/utils/animations';

interface ManualCampaignSectionProps {
  isInGrid?: boolean;
}

const ManualCampaignSection = ({ isInGrid = false }: ManualCampaignSectionProps) => {
  const isMobile = useIsMobile();
  
  if (isInGrid) {
    return (
      <motion.div 
        className="flex flex-col space-y-4"
        variants={fadeInRight}
      >
        <div className="space-y-4">
          <div className="feature-icon bg-munger-blue/10 text-munger-blue inline-flex p-3 rounded-lg">
            <Terminal size={isMobile ? 24 : 28} />
          </div>
          <h3 className="text-2xl font-bold text-white">Manual Campaign Management</h3>
          <p className="text-munger-lightgray text-lg mb-6">
            Take control when needed with comprehensive manual campaign tools and settings.
          </p>
        </div>
      </motion.div>
    );
  }
  
  return (
    <section className="section bg-munger-dark py-16">
      <motion.div 
        className="max-w-6xl mx-auto px-6"
        variants={fadeIn}
      >
        <motion.div 
          className="flex flex-col space-y-4"
          variants={fadeInRight}
        >
          <div className="space-y-4">
            <div className="feature-icon bg-munger-blue/10 text-munger-blue inline-flex p-3 rounded-lg">
              <Terminal size={isMobile ? 24 : 28} />
            </div>
            <h3 className="text-2xl font-bold text-white">Manual Campaign Management</h3>
            <p className="text-munger-lightgray text-lg mb-6">
              Take control when needed with comprehensive manual campaign tools and settings.
            </p>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default ManualCampaignSection;
